import {
  filterModuleHasContent,
  mergeCustomOutputToAPIFiltersFormat,
  parseFilterModuleFiltersFromCubeFilters,
  ruleItemInjector,
} from "../../../helper/Quadrant/quadrantHelper";
import {
  PlatformWiseKeyMapper,
  PlatformWiseQueryMeasures,
  PlatformWiseQueryOrder,
} from "../../../components/Filter/FilterData/quadrantFilter";

export { filterModuleHasContent };

const EXCLUDED_CAMPAIGN_ABO_MEASURES = [
  "VariantAnalysisTablePPMPlaceholder.BSR",
];


function formatDate(d) {
  return d.toISOString().slice(0, 10);
}

function dateRangeForPeriod(timePeriod) {
  const end = new Date();
  const start = new Date();
  const days = timePeriod === "LAST_14_DAY" ? 14 : 7;
  start.setDate(end.getDate() - days);
  return [formatDate(start), formatDate(end)];
}

/** Build entity_metric_filter.cube_filters for Campaign ABO save payload. */
export function buildCubeFiltersFromFilterModule(
  filterModuleFilters,
  { timePeriod = "LAST_7_DAY", platformCampaignIds = [], userPlatform = "amazon" } = {}
) {
  if (!filterModuleHasContent(filterModuleFilters)) return "";

  const merged = mergeCustomOutputToAPIFiltersFormat(
    filterModuleFilters?.metrics?.custom_output,
    filterModuleFilters?.dimension?.custom_output,
    filterModuleFilters?.campaigns?.custom_output,
    filterModuleFilters?.topX?.custom_output
  );

  if (!Object.keys(merged).length) return "";

  let filters = merged;
  if (platformCampaignIds?.length) {
    filters = ruleItemInjector(filters, "dimensions", [
      {
        type: "RULE_ITEM",
        member: "campaign_id",
        operator: "in",
        values: platformCampaignIds.map(String),
      },
    ]);
  }

  const [dateStart, dateEnd] = dateRangeForPeriod(timePeriod);
  const resolvedPlatform = userPlatform || "amazon";
  const rawMeasures = resolvedPlatform === "amazon" ? PlatformWiseQueryMeasures["amazonCampaignABO"] : PlatformWiseQueryMeasures[resolvedPlatform];
  const filteredMeasures = rawMeasures.filter(
    (measure) => !EXCLUDED_CAMPAIGN_ABO_MEASURES.includes(measure)
  );
  const measures = filteredMeasures;
  const dimensions = ["campaign_id"];
  const order = resolvedPlatform === "amazon" ? PlatformWiseQueryOrder["amazonCampaignABO"] : PlatformWiseQueryOrder[resolvedPlatform] || PlatformWiseQueryOrder.amazon || [];
  const dateDimension = resolvedPlatform === "amazon" ? PlatformWiseKeyMapper["amazonCampaignABO"]?.date : PlatformWiseKeyMapper[resolvedPlatform]?.date;

  return JSON.stringify({
    query: {
      measures,
      dimensions,
      timeDimensions: [{ dimension: dateDimension, dateRange: [dateStart, dateEnd] }],
      filters,
      limit: 50,
      order,
    },
  });
}

/** Load edit form filters from entity_metric_filter.cube_filters. */
export function hydrateFilterModuleFromCubeFilters(cubeFiltersRaw) {
  return parseFilterModuleFiltersFromCubeFilters(cubeFiltersRaw, {
    stripMembers: ["campaign_id"],
  });
}
